export type KursCategory = "rachunkowosc" | "doradca-podatkowy" | "pit" | "cit" | "cit-eston" | "podstawy-prawa-podatkowego" | "kontrole-postep" | "vat" | "podatki-od-podstaw" | null;

export interface Kurs {
	slug: string;
	title: string;
	description: string;
	category: KursCategory;
	level: "podstawa" | "rozszerzenie" | "generalny" | null;
}

export const KursyGeneralList: Array<Kurs> = [
	{
		slug: "kurs-rachunkowosc",
		title: "Kurs rachunkowość od podstaw",
		description:
			"Praktyczny kurs, który w krótkim czasie wyposaży Cię w wiedzę i umiejętności potrzebne do swobodnej pracy w świecie księgowości i finansów.",
		category: "rachunkowosc",
		level: "generalny",
	},
	// {
	// 	slug: "kurs-doradca-podatkowy",
	// 	title: "Kurs Doradca Podatkowy",
	// 	description:
	// 		"Kompleksowy kurs, który przygotuje Cię do egzaminu ustnego i pisemnego na Doradcę Podatkowego. Oparty na realnych pytaniach i przykładach.",
	// 	category: "doradca-podatkowy",
	// 	level: "generalny",
	// },
	{
		slug: "pop",
		title: "Kurs podatki od podstaw",
		description: "",
		category: "podatki-od-podstaw",
		level: "generalny",
	},
];